import { el } from 'redom';

class InputBox {

  constructor(configuration) {

    this.errored = false;

    this.input = configuration.input;
    this.error = this.renderError();

    this.el = el('.field-input-and-error', [
      this.input,
      this.error
    ]);

  }

  renderError() {

    return el('label.error-message');

  }

  setValue(value) {

    this.input.setValue(value);

  }

  setError(errorMessage) {

    this.errored = true;

    this.error.textContent = errorMessage;

  }

  clearError() {

    if (this.errored === false) {
      return;
    }

    this.errored = false;

    this.error.textContent = '';

  }

  reset() {

    this.input.reset();
    this.clearError();

  }

  getValue() {

    return this.input.getValue();

  }

  focus() {

    this.input.focus();

  }

  configure(options) {

    this.input.configure(options);

  }

  enable() {

    this.input.setReadOnly(false);

  }

  disable() {

    this.input.setReadOnly(true);

  }

  setReadOnly(readOnly) {

    this.input.setReadOnly(readOnly);

  }

  hide() {

    this.el.classList.add('hidden');

  }

  show() {

    this.el.classList.remove('hidden');

  }

}

export default InputBox;